import { JOURNEY_TYPES } from 'core/constants';

import type { NomineeFormData } from './nomineeInfo.types';

export const NOMINEE_RELATION_VALUE_OTHERS = 'OTHERS';

export const NOMINEE_RELATION_OPTIONS = [
  { value: 'WIFE', label: 'Wife' },
  { value: 'HUSBAND', label: 'Husband' },
		{ value: 'MOTHER', label: 'Mother' },
  { value: 'FATHER', label: 'Father' },
  { value: 'SON', label: 'Son' },
  { value: 'DAUGHTER', label: 'Daughter' },
		{ value: 'SISTER', label: 'Sister' },
  { value: 'BROTHER', label: 'Brother' },
  { value: NOMINEE_RELATION_VALUE_OTHERS, label: 'Others' },
];

export const GUARDIAN_RELATION_OPTIONS = [
  { value: 'FATHER', label: 'Father' },
  { value: 'MOTHER', label: 'Mother' },
  { value: 'BROTHER', label: 'Brother' },
  { value: 'SISTER', label: 'Sister' },
  { value: 'GRAND_FATHER', label: 'Grand Father' },
  { value: 'GRAND_MOTHER', label: 'Grand Mother' },
  { value: 'OTHERS', label: 'Others' },
];

export const IDENTITY_PROOF_OPTIONS = [
  { value: 'AADHAAR', label: 'Aadhaar Number' },
  { value: 'PAN', label: 'PAN Number' },
  { value: 'DL', label: 'Driving Licence Number' },
];

export const STATE_CODES = [
	{
		label: 'Andaman & Nicobar Islands',
		value: 'AN',
	},
	{
		label: 'Andhra Pradesh',
		value: 'AP',
	},
	{
		label: 'Arunachal Pradesh',
		value: 'AR',
	},
	{
		label: 'Assam',
		value: 'AS',
	},
	{
		label: 'Bihar',
		value: 'BH',
	},
	{
		label: 'Chandigarh',
		value: 'CH',
	},
	{
		label: 'Chattisgarh',
		value: 'CG',
	},
	{
		label: 'Dadra & Nagar Haveli',
		value: 'DN',
	},
	{
		label: 'Daman & Diu',
		value: 'DD',
	},
	{
		label: 'Delhi',
		value: 'ND',
	},
	{
		label: 'Goa',
		value: 'GO',
	},
	{
		label: 'Gujarat',
		value: 'GU',
	},
	{
		label: 'Haryana',
		value: 'HA',
	},
	{
		label: 'Himachal Pradesh',
		value: 'HP',
	},
	{
		label: 'Jammu and Kashmir',
		value: 'JM',
	},
	{
		label: 'Jharkhand',
		value: 'JK',
	},
	{
		label: 'Karnataka',
		value: 'KA',
	},
	{
		label: 'Kerala',
		value: 'KE',
	},
	{
		label: 'Lakshadweep',
		value: 'LD',
	},
	{
		label: 'Madhya Pradesh',
		value: 'MP',
	},
	{
		label: 'Maharashtra',
		value: 'MA',
	},
	{
		label: 'Pondicherry',
		value: 'PO',
	},
	{
		label: 'Manipur',
		value: 'MN',
	},
	{
		label: 'Mizoram',
		value: 'MI',
	},
	{
		label: 'Nagaland',
		value: 'NA',
	},
	{
		label: 'Tripura',
		value: 'TR',
	},
	{
		label: 'Meghalaya',
		value: 'ME',
	},
	{
		label: 'Odisha',
		value: 'OR',
	},
	{
		label: 'Punjab',
		value: 'PU',
	},
	{
		label: 'Rajasthan',
		value: 'RA',
	},
	{
		label: 'Tamil Nadu',
		value: 'TN',
	},
	{
		label: 'Uttar Pradesh',
		value: 'UP',
	},
	{
		label: 'Uttarakhand',
		value: 'UC',
	},
	{
		label: 'West Bengal',
		value: 'WB',
	},
	{
		label: 'Sikkim',
		value: 'SI',
	},
	{
		label: 'Orissa',
		value: 'OR',
	},
	{
		label: 'Telangana',
		value: 'TG',
	},
];

export const INITIAL_NOMINEE_FORM: NomineeFormData = {
  nomineeId: null,
  name: '',
  relation: '',
  relationshipDescription: '',
  emailId: '',
  mobileNumber: '',
  identityProofType: '',
  identityProofNumber: '',
  isMinor: false,
  originalContactDetails: null,
  guardianName: '',
  guardianRelation: '',
  percentageShare: 100,
  isPrimary: true,
};

export const NOMINEE_FORM_COPY = {
  ADDITIONAL_DETAILS_LABEL: 'Enter additional details',
  OPTIONAL_SUFFIX: '(optional)',
  ADULT_CHECKBOX_LABEL: 'Nominee is 18 years and older',
};

export const NOMINEE_OPT_OUT_DECLARATION_COPY = {
  TITLE: 'Before you skip nominee',
  BODY_INTRO:
    'I hereby confirm that I do not wish to appoint any nominee(s) to my demat account/mutual fund folio at this point in time. I understand that:',
  BODY_POINTS: [
    'Nomination enables quick, smooth transmission of securities to my legal heirs.',
    'In the absence of a nomination, legal heirs may be required to submit additional legal documentation, which could delay transmission.',
    'In accordance with SEBI regulations, unclaimed holdings may eventually be transferred to the Investor Education and Protection Fund (IEPF). I confirm that this decision to opt out of nomination is entirely voluntary.',
  ],
  GO_BACK_CTA: 'Go back',
  CONFIRM_CTA: 'Will do it later',
};

export const ROMAN_NUMERALS = ['i', 'ii', 'iii'];

export const NOMINEE_ANALYTICS = {
  SCREEN_NOMINEE_DETAILS: 'NomineeComplianceNomineeDetailsScreen',
  CTA_SAVE_AND_CONTINUE: 'Save&Continue',
  CTA_SKIP_FOR_NOW: 'SkipForNow',
  CTA_ENTER_ADDITIONAL_DETAILS: 'EnterAdditionalDetails',
  SCREEN_REVIEW: 'NOMINEE_LISTING_COSMOS_SCREEN',
  CTA_NOMINEE_SAVE: 'Nominee_Save',
} as const;

// Store local storage flag for the following journeys only. Delta journeys show the declaration only no flag stored.
export const JOURNEYS_ELIGIBLE_FOR_NOMINEE_RECHECK: string[] = [JOURNEY_TYPES.MAIN_ONBOARDING];

export const NOMINEE_FORM_ERRORS = {
  INVALID_NAME: 'Please enter a valid nominee name (alphabets only)',
  SHORT_NAME: 'Name should contain at least 2 characters',
  SELECT_RELATION: 'Please select relation to the nominee',
  SPECIFY_RELATION_OTHER: 'Please enter relation to the nominee',
  RELATION_OTHER_TOO_LONG: 'Relation must be at most 100 characters',
  INVALID_EMAIL: 'Please enter a valid email address',
  EMPTY_EMAIL: 'Please enter an email address',
  INVALID_MOBILE: 'Please enter a valid 10-digit mobile number',
  EMPTY_MOBILE: 'Please enter a mobile number',
  SELECT_PROOF_TYPE: 'Please select identity proof type',
  INVALID_PROOF_NUMBER: 'Please enter a valid proof number',
  INVALID_ADDRESS: 'Please enter a valid address',
  INVALID_PINCODE: 'Please enter a valid 6-digit pincode',
  INVALID_CITY: 'Please enter a valid city',
  INVALID_STATE: 'Please enter a valid state',
  INVALID_DOB: 'Please enter a valid date of birth (DD/MM/YYYY)',
  INVALID_GUARDIAN_NAME: 'Please enter a valid guardian name',
  SHORT_GUARDIAN_NAME: 'Guardian name should contain at least 2 characters',
  SELECT_GUARDIAN_RELATION: 'Please select guardian\'s relation to nominee',
  SHARE_SUM_ERROR: 'Total percentage share must equal 100%',
  SHARE_ZERO_ERROR: 'Percentage share cannot be 0',
  SHARE_DECIMAL_ERROR: 'Percentage share must be a whole number',
};

export const MAX_NOMINEES = 3;

export const NOMINEE_SCREENS = {
  FORM: 'form',
  REVIEW: 'review',
} as const;
